import Modal from '../../../components/Modal'
import { formatNumber } from '../../../utilities/Format'

const SaveDraftDialog = ({ 
  id, show, operationNo, workCenter, orderQty, unit,
  onCancel, onConfirm, logs }) => {

  let totalYield = sumYield(logs)
  if (totalYield === 0) {
    totalYield = sumBulkUsed(logs)
  }
  
  return <Modal
    show={show}
    title='ยืนยันการจบขั้นตอน'
    cancelText={totalYield > 0 ? 'ยกเลิก':'ปิด'}
    onHide={onCancel}
    okText={totalYield > 0 ? 'ยืนยัน' : null}
    okTheme='success'
    okAction={() => onConfirm(id)}
  >
    {totalYield > 0 ? <div>
      <label className='inline-block mt-2 '>คุณกำลังจะยืนยันการจบขั้นตอนด้วยข้อมูลทั้งหมดดังนี้</label>
      <div className='grid grid-cols-2 gap-3 mt-2'>
        <div className='flex flex-col'>
          <small>Operation</small>
          <label className="font-bold">{operationNo}</label>
        </div>
        <div className='flex flex-col'>
          <small>Work Center</small>
          <label className="font-bold">{workCenter.actualWorkCenterDescription ? workCenter.actualWorkCenterDescription : workCenter.workCenterDescription} ({workCenter.actualWorkCenterId ? workCenter.actualWorkCenterId : workCenter.workCenterId})</label>  
        </div>
        <div className='flex flex-col'>
          <small>Order Qty</small>
          <label className="font-bold">{formatNumber(orderQty)} {unit}</label>
        </div>
        <div className='flex flex-col'>
          <small>ผลิตได้จริง</small>
          <label className="font-bold">{formatNumber(totalYield)} {unit}</label>
        </div>
      </div>
    </div> : <label>ยังไม่มีการบันทึกข้อมูล</label>
    }
  </Modal>
}

const sumYield = (logs) => {
  return logs.reduce((prev, cur) => prev + (cur.yield ? cur.yield : 0), 0)
}

const sumBulkUsed = (logs) => {
  return logs.reduce((prev, cur) => prev + (cur.bulkUsedQty ? cur.bulkUsedQty : 0), 0)
}

export default SaveDraftDialog